export default "// test/setup.js\n\nimport Vue from 'vue'\nimport Vuetify from 'vuetify'\n\nVue.use(Vuetify)\n";